import React, {useState, useEffect} from 'react'
import useQuery from '@/hooks/useQuery'
import { useForm } from 'react-hook-form'
import { ExclamationCircleIcon, EmojiHappyIcon, LinkIcon, DuplicateIcon } from '@heroicons/react/solid'
import PrimaryButton from '@/shared/Buttons/Primary'

import { showNonSpaToast } from '@/utils/nonSpaToast'
import HeroForm from '@/pages/teachers/LandingPage/HeroForm'
import CourseImage from '@/pages/teachers/LandingPage/CourseImage'
import InstructorList from '@/pages/teachers/LandingPage/InstructorList'
import OverviewForm from '@/pages/teachers/LandingPage/OverviewForm'
import VideoUrlForm from '@/pages/teachers/LandingPage/VideoUrlForm'
import OutcomeHeaderForm from '@/pages/teachers/LandingPage/OutcomeHeaderForm'
import TestimonialHeaderForm from '@/pages/teachers/LandingPage/TestimonialHeaderForm'
import InstructorHeaderForm from '@/pages/teachers/LandingPage/InstructorHeaderForm'
import OutlineHeaderForm from '@/pages/teachers/LandingPage/OutlineHeaderForm'
import ScheduleHeaderForm from '@/pages/teachers/LandingPage/ScheduleHeaderForm'
import BenefitHeaderForm from '@/pages/teachers/LandingPage/BenefitHeaderForm'
import FaqHeaderForm from '@/pages/teachers/LandingPage/FaqHeaderForm'

const LandingPage = (props) => {
  const { course } = props
  return <>
    <div id="course_name" className="mx-auto py-8 px-4 sm:py-10 sm:px-6 lg:px-8">
      <div className="text-center">
        <h1 className="mt-1 text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-6xl">{course.name}</h1>
      </div>
    </div>

    <div id="hero">
      <div id="hero" className="space-y-3 grid sm:grid-cols-2 sm:space-y-0 space-x-4">
        <div className="sm:col-span-1 flex flex-col space-y-4">
          <HeroForm course={course} />
          <div className="max-w-md prose-product-sm flex items-center sm:prose-product-lg">
            <input type="text" className={'placeholder-shown:italic placeholder-gray-600 p2 py-3.5 px-4 w-full border rounded-lg'} placeholder="sally@sample.com" />
          </div>
          <div className='flex mt-2 items-end'>
            <div className="text-gray-700">Get notified about the next cohort</div>
            <svg className="mb-1.5" width="48" height="30" viewBox="0 0 64 41" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M38.7008 28.984L39.0564 29.3588L38.7008 28.984ZM51.7585 0.648594C51.963 0.483508 52.3023 0.507007 52.5161 0.701084L56.0016 3.86374C56.2155 4.05782 56.2231 4.34897 56.0185 4.51406C55.8139 4.67915 55.4747 4.65565 55.2608 4.46157L52.1626 1.65033L49.1996 4.04166C48.9951 4.20675 48.6558 4.18325 48.442 3.98918C48.2281 3.7951 48.2205 3.50394 48.4251 3.33885L51.7585 0.648594ZM8.57898 35.9605C8.61514 35.5059 8.61499 35.5058 8.6149 35.5058C8.61495 35.5058 8.61492 35.5058 8.61503 35.5058C8.61523 35.5059 8.61569 35.5059 8.61638 35.506C8.61778 35.5062 8.62015 35.5066 8.62348 35.507C8.63016 35.508 8.64071 35.5095 8.65506 35.5114C8.68376 35.5153 8.72766 35.521 8.7862 35.5283C8.90329 35.5427 9.07893 35.563 9.30861 35.5858C9.76801 35.6312 10.4434 35.6864 11.2989 35.7239C13.0102 35.7989 15.44 35.8031 18.3017 35.5184C24.0256 34.9489 31.4655 33.225 38.3453 28.6092L39.0564 29.3588C32.0071 34.0883 24.3861 35.8527 18.5313 36.4352C15.6036 36.7264 13.1147 36.7225 11.3546 36.6454C10.4744 36.6068 9.77589 36.5499 9.29533 36.5023C9.05504 36.4786 8.86918 36.4571 8.74227 36.4414C8.67881 36.4336 8.63009 36.4272 8.59666 36.4227C8.57995 36.4204 8.56706 36.4186 8.55806 36.4174C8.55356 36.4167 8.55004 36.4162 8.5475 36.4159C8.54623 36.4157 8.5452 36.4155 8.54442 36.4154C8.54403 36.4154 8.54363 36.4153 8.54344 36.4153C8.5431 36.4152 8.54283 36.4152 8.57898 35.9605ZM38.3453 28.6092C45.1929 24.0151 48.5171 17.1205 50.1247 11.3376C50.9274 8.45024 51.2988 5.85164 51.4695 3.97575C51.5548 3.03811 51.5899 2.28187 51.6036 1.76142C51.6105 1.50122 51.6121 1.30003 51.6119 1.16466C51.6118 1.09698 51.6114 1.04575 51.6109 1.01183C51.6106 0.994878 51.6104 0.982251 51.6103 0.974056C51.6102 0.969958 51.6101 0.966971 51.6101 0.965104C51.61 0.964172 51.61 0.963519 51.61 0.96315C51.61 0.962964 51.61 0.962898 51.61 0.962806C51.61 0.962811 51.61 0.962886 52.1458 1C52.6815 1.03712 52.6815 1.03733 52.6815 1.03762C52.6815 1.03782 52.6815 1.03818 52.6815 1.03856C52.6816 1.03932 52.6816 1.04037 52.6816 1.0417C52.6817 1.04435 52.6818 1.04814 52.6819 1.05304C52.682 1.06283 52.6823 1.07708 52.6826 1.09567C52.6831 1.13286 52.6836 1.18744 52.6837 1.25855C52.6838 1.40077 52.6822 1.60915 52.6751 1.87685C52.6609 2.41222 52.625 3.18514 52.5381 4.1409C52.3642 6.05182 51.9861 8.69699 51.1687 11.6375C49.5361 17.5103 46.1379 24.6077 39.0564 29.3588L38.3453 28.6092Z" fill="currentColor"></path>
            </svg>
          </div>
        </div>
        <div className="sm:col-span-1">
          <CourseImage course={course} />
        </div>
      </div>
    </div>

    <div id="instructors_overview" className="mt-6 space-y-3 flex sm:space-y-0 relative space-x-4">
      <div className="w-2/3 flex flex-col space-y-4">
        <InstructorList course={course} />
        <VideoUrlForm course={course} />
        <OverviewForm course={course} />
        <OutcomeHeaderForm course={course} />

      </div>

      <aside className="hidden lg:block -mt-28 relative w-1/3 pb-4">
        <div className="sticky top-8 space-y-8">
          <div className="space-y-8 bg-white md:shadow-lg md:rounded-lg md:border md:border-gray-300 md:p-6">
            <div>
              <div className="flex items-center justify-between">
                <div className="text-lg font-semibold">
                  <p>$XX USD</p>
                </div>
              </div>
              <div className="mt-2">
                <a target="_blank" href="https://closingcredits.feather.blog/reimbursement">
                  <p className="text-sm text-black underline">Get reimbursed by your employer</p>
                </a>
              </div>
            </div>
            <div className="space-y-4 md:space-y-8">
              <div className="space-y-4 md:space-y-6">
                <p className="text-sm uppercase text-gray-700">Upcoming cohort</p>
                <div>
                  <p className="text-lg font-semibold">Cohort #</p>
                  <p className="text-lg">Start Date - End Date</p>
                  <p className="mt-4">Last day to apply: Final Pay Date</p>
                </div>
                <div className="prose-product-sm sm:prose-product-lg"><button data-cy="" className="inline-flex mr-3 justify-center px-4 py-2 text-sm font-medium rounded-md text-white hover:text-white bg-gradient-to-r from-clcpurple to-clcnavy hover:from-clcnavy hover:to-clcpurple py-4 w-full" type="button">Enroll today</button></div>
              </div>
              <div className="space-y-2">
                <p className="text-sm uppercase text-gray-700">Can't join this time?</p>
                <p className="text-xs text-gray-900">Stay in the loop about future cohorts</p>
                <div className=" h-14 w-full sm:max-w-100">
                  <div className="flex bg-white border shadow-sm hover:shadow-md rounded-2xl p-1 font-graphik transition ease-out duration-200 h-full items-center border-gray-300 focus-within:border-gray-900 hover:border-gray-400">
                    <input className="disabled:bg-white border-none w-full shrink grow-0 text-gray-600 placeholder-gray-600 focus:text-gray-900 focus:outline-none p3 px-1 sm:p2 sm:px-2" type="email" placeholder="Your email" />
                      <button aria-label="submit" className="clp-bg-primary shrink-0 rounded-xl text-white h-10">
                        <span className="flex items-center px-6">
                          <svg className="shrink-0" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M7.67155 1.33333L14.6667 8L7.67155 14.6667L6.93842 13.9206L12.606 8.5191H1.33333V7.48089H12.606L6.93842 2.07939L7.67155 1.33333Z" fill="currentColor"></path>
                          </svg>
                        </span>
                      </button>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </div>
    <TestimonialHeaderForm course={course} />
    <InstructorHeaderForm course={course} />
    <OutlineHeaderForm course={course} />
    <ScheduleHeaderForm course={course} />
    <BenefitHeaderForm course={course} />
    <FaqHeaderForm course={course} />
  </>
}

export default LandingPage
